let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let radio = require('ES/lib/radio');
let Modal = require('ES/widgets/Modal');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require("react-loose-forms");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ezVerticalFields = require("react-loose-forms.bootstrap3/layouts/ezVerticalFields");
let AuthedUserSession = require('../../utils/AuthedUserSession');

let DaForm = dd.createClass({
    mixins: [FormMixin],
    buildSchema(){
        return {
            note: {
                label: 'Enter a brief note explaining why you cancelled this event.',
                type: 'textarea'
            }
        };
    },
    render(){
        return dd.form({onSubmit: this.Form_onSubmit},
            ezVerticalFields(this),
            dd.div(null,
                dd.button({className: 'btn btn-primary', type: 'submit'}, 'Save'),
                ' ',
                dd.button({className: 'btn btn-default', onClick: this.props.onCancel}, 'No thanks')
            )
        );
    }
});

module.exports = dd.createClass({
    mixins: [RadioMixin],
    getInitialState(){
        return {event_to_note_on: null};
    },
    Radio_setup(){
        return {
            prompt_for_why_canceling_event(event){
                let Displaylists = this.props.Displaylists || {};
                let preferences = (Displaylists.user && Displaylists.user.myevents_preferences) || {};
                if (preferences.ask_for_reason_when_canceling_or_releasing) {
                    this.setState({event_to_note_on: event});
                }
            }
        };
    },
    __close: esUtils.wrapPreventDefault(function () {
        this.setState({event_to_note_on: null});
    }),
    __onSubmit(data){
        let event = _.cloneDeep(this.state.event_to_note_on);
        if (!_.isArray(event.Note)) {
            event.Note = [];
        }
        event.Note.push({
            id: 0,
            eid: event.eid,
            content: data.note,
            datetime: new Date(),
            enteredby: AuthedUserSession.MY_USERNAME
        });
        event.Note = _.sortBy(event.Note, 'datetime').reverse();
        radio('save_Event').broadcast(event);
        this.setState({event_to_note_on: null});
    },
    render(){
        if (!this.state.event_to_note_on) {
            return dd.div();
        }
        return Modal({
                title: 'Make a note about why you canceled/released this event',
                buttons: [{name: "Got It.", onClick: this.__close, className: 'btn btn-default'}],
                onClose: this.__close
            },
            dd.div({className: 'row'},
                dd.div({className: 'col-sm-3 text-center text-muted'},
                    dd.i({className: 'fa fa-pencil-square-o', style: {fontSize: "3em"}})
                ),
                dd.div({className: 'col-sm-9'},
                    DaForm({onSubmit: this.__onSubmit, onCancel: this.__close})
                )
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/modals/PromptForReasonWhenCanceling.js